// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually
import React from 'react';

const IconFolderTop = (props: React.SVGProps<SVGElement>) =>
  /*#__PURE__*/ React.createElement(
    'svg',
    {
      width: '37',
      height: '11',
      viewBox: '0 0 37 11',
      xmlns: 'http://www.w3.org/2000/svg',
      ...props
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M31.974 5.54734e-06H4.23696C1.98965 -0.00366554 0.16481 1.8152 0.161139 4.0626C0.160833 4.24546 0.17284 4.4281 0.197161 4.60928C0.254981 5.05608 0.664077 5.37142 1.11096 5.3136C1.21979 5.29952 1.32464 5.26365 1.41925 5.20805C1.77917 4.99865 2.18903 4.89043 2.60539 4.89479H8.41389C9.46214 4.89769 10.3934 5.56438 10.734 6.55572L10.8727 7.00275C11.434 8.66446 12.9905 9.78475 14.7445 9.78949H33.6056C34.0335 9.78987 34.4537 9.90238 34.8244 10.1158C34.9497 10.1889 35.0922 10.2271 35.2372 10.2268C35.6878 10.2268 36.053 9.86154 36.053 9.41099V4.07896C36.053 1.82622 34.2268 5.54734e-06 31.974 5.54734e-06Z',
      fill: 'current'
    })
  );

export { IconFolderTop };
